const autoNgTemplateLoaderTemplate1 = require('./licenses.view.html');

import controller from './licenses.view.controller.js';

export const licensesView = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
};
